/**
 * Numbers for the post-trial "Free cases remaining" line.
 * Onboarding bonus credits are extra free cases and belong in this count.
 */
export function freeCaseBannerCounts(entitlements) {
  const freeRemaining = Number(entitlements?.free_cases_remaining) || 0;
  const freeLimit = Number(entitlements?.free_cases_limit) || 0;
  const bonusRemaining = Number(entitlements?.onboarding_bonus_cases_remaining) || 0;
  const granted = Boolean(entitlements?.onboarding_bonus_granted);
  const configuredLimit = Number(entitlements?.onboarding_bonus_cases_limit);
  const bonusLimit = granted
    ? (Number.isFinite(configuredLimit) && configuredLimit > 0
      ? configuredLimit
      : bonusRemaining)
    : 0;
  return {
    remaining: freeRemaining + bonusRemaining,
    limit: freeLimit + bonusLimit,
  };
}
